/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Form, Input, Row, Spin, Typography } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Layout from 'components/layout/Layout';
import { formatPrice } from 'helpers/formatPrice';
import Masonry from 'react-smart-masonry';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
   getProductSubCatagories,
   getProductSubCatProduct,
   getTokenProduct,
} from 'helpers/GetInitSubProduct';
import { ec } from 'helpers/Crypto';
import { phoneNumber } from 'helpers/Number';

const { Text } = Typography;
const DompetEL = () => {
   const { slug } = useParams();
   const [isLastPage, setIsLastPage] = useState(false);
   const [loading, setLoading] = useState(false);
   const [isDisable, setIsDisable] = useState(true);
   const [page, setPage] = useState(0);
   const [products, setProducts] = useState([]);
   const [poinBOS, setPoinBOS] = useState(0);

   const [noHP, setNoHP] = useState(false);

   const location = useLocation();
   const id = location.state?.id;
   const navigate = useNavigate();

   const getInitData = useCallback(
      async (loadMore = false) => {
         !loadMore ? setPage(1) : setPage(page + 1);
         let productSubcategoryId = await getProductSubCatagories(id);
         let params = [];
         params.push(`_limit=14`);
         params.push(`page=${loadMore ? page + 1 : page || 1}`);
         let product = await getProductSubCatProduct(
            productSubcategoryId?.[0]?.id,
            `&${params.join('&')}`,
         );
         setProducts([...products, ...product]);
         if (loadMore && product?.length < 14) {
            setIsLastPage(true);
            return true;
         }
      },
      [isLastPage, page, products, slug],
   );
   useEffect(() => {
      setPoinBOS(localStorage.getItem('poinBOS') || 0);
      getInitData(true);
   }, []);
   const loadMoreData = useCallback(async () => {
      if (isLastPage) {
         return;
      } else {
         setPage(page + 1);
         setTimeout(() => {
            getInitData(true);
         }, 1000);
      }
   }, [getInitData, isLastPage, page]);

   const handleNoHPChange = (evt) => {
      if (evt.target.value.length < 13 && evt.target.value.length > 0) {
         setIsDisable(false);
         setNoHP(evt.target.value);
      } else {
         setIsDisable(true);
      }
   };

   const handleOrder = async (data) => {
      setLoading(true);
      console.log(noHP, 'AKSJKAJSKS');
      const body = {
         product_id: data?.id, // Get `product_id` references from product hierarchy
         phone: ec(phoneNumber(noHP)),
      };
      try {
         let chekout = await getTokenProduct(
            'ewallet',
            body,
            data?.product_supplier?.code,
         );

         navigate('/konfirmasi-pembayaran', {
            state: {
               data: data,
               initproduct: 'ewallet',
               phone: noHP,
               token: chekout.meta?.token,
            },
         });
         setLoading(false);
      } catch (error) {
         setLoading(false);
      }
   };
   const cekTagihan = (data) => {
      console.log(data?.product_supplier?.code === 'AYOCONNECT');
      if (data?.product_supplier?.code === 'AYOCONNECT') {
         handleOrder(data);
      } else {
         navigate('/konfirmasi-pembayaran', {
            state: {
               data: data,
               initproduct: 'ewallet',
               phone: noHP,
            },
         });
      }
   };
   return (
      <>
         {loading && (
            <div>
               <Spin size="large" className="spin-area"></Spin>
               <div className="loading-spin"></div>
            </div>
         )}
         <Layout header="product" headerTitle={slug}>
            <Row className="container-index Top-UP">
               <Form name="basic">
                  <Form.Item hasFeedback>
                     <Input
                        type="number"
                        placeholder="Masukan Nomor HP"
                        id="validating"
                        className="input-topUP"
                        onChange={handleNoHPChange}
                        allowClear
                     />
                  </Form.Item>
               </Form>
               <Row className="row-icon-DompetEL" style={{ marginTop: 10 }}>
                  <InfiniteScroll
                     dataLength={products.length}
                     next={loadMoreData}
                     hasMore={!isLastPage}
                     loader={
                        <div
                           className="center"
                           style={{
                              marginTop: 20,
                              textAlign: 'center',
                              maxWidth: '400px',
                           }}
                        >
                           <Spin />
                        </div>
                     }
                     className="section-infinite-scroll produk-serupa"
                     style={{ overflow: 'visible' }}
                  >
                     <Masonry columns={2} gap={10}>
                        {products?.map((item, index) => (
                           <Col
                              span={24}
                              key={index}
                              onClick={
                                 !isDisable
                                    ? item?.is_purchasable &&
                                      item?.product_price?.total < poinBOS
                                       ? () => cekTagihan(item)
                                       : null
                                    : null
                              }
                              className={
                                 !isDisable
                                    ? item?.is_purchasable &&
                                      item?.product_price?.total < poinBOS
                                       ? 'enable'
                                       : 'disable'
                                    : 'disable'
                              }
                           >
                              <div className="DompetEL-text">
                                 <Text>
                                    <strong>{item.name}</strong>
                                 </Text>
                                 <Text className="price">
                                    {formatPrice(item?.product_price?.total)}
                                 </Text>
                                 {!isDisable ? (
                                    !item?.is_purchasable ? (
                                       <Text className="dalam-kendala">
                                          Dalam Kendala
                                       </Text>
                                    ) : item?.product_price?.total > poinBOS ? (
                                       <Text className="dalam-kendala">
                                          Poin tidak cukup
                                       </Text>
                                    ) : null
                                 ) : null}
                              </div>
                           </Col>
                        ))}
                     </Masonry>
                  </InfiniteScroll>
               </Row>
            </Row>
         </Layout>
      </>
   );
};

export default DompetEL;
